function TextArea({ id, label, value, onInput }) {
    return (
        <div class="form-floating mb-3">
            <textarea class="form-control" id={id} name={id} style="height:100px" onInput={onInput} defaultValue={value} />
            <label class="form-label" for={id}>{label}</label>
        </div>
    )
}

export default TextArea;